import React, { useMemo } from 'react';
import ProductCard from '../Components/ProductCards/ProductCard';
import BannerItem from './BannerBlock/_banner-item';
import { BannerBlockProps } from './BannerBlock/BannerBlock';
import { ProductNoSliderProps } from './ProductBlockNoSlider';
import { LinkModel } from '../Types/LinkModel';
import clsx from 'clsx';

interface ProductAndBannerProps {
  products: ProductNoSliderProps;
  banners: BannerBlockProps;
  showBannerToTheRight: boolean;
  productQuantity: number;
  title?: string;
  link?: LinkModel;
}

const ProductsAndBannerBlock = ({
  products: productsBlock,
  banners: bannersBlock,
  showBannerToTheRight,
  title,
  link,
}: ProductAndBannerProps) => {
  const bannerBlockItem = useMemo(
    () => (bannersBlock.banners?.length ? bannersBlock.banners[0] : null),
    [bannersBlock.banners]
  );

  const firstTwoProducts = useMemo(
    () => productsBlock.products?.slice(0, 2),
    [productsBlock]
  );
  const remainingProducts = useMemo(
    () => productsBlock.products?.slice(3),
    [productsBlock]
  );

  if (!bannerBlockItem) return null;
  return (
    <>
      {title && (
        <div className="grid grid-cols-2 mb-6 gap-1">
          <div className="flex items-center">
            {title && <h2 className="section_title">{title}</h2>}
          </div>
          <div className="flex items-center justify-end">
            {link?.href && (
              <a href={link.href} className="text-lg underline">
                {link.text}
              </a>
            )}
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 h-full gap-1 lg:grid-cols-2">
        <div className={clsx(showBannerToTheRight && 'lg:hidden')}>
          <BannerItem
            className="banner-item [&_p]:text-white [&_h2]:text-white lg:h-full lg:[&_.banner-item__image]:h-full lg:[&_.banner-item__image]:aspect-auto"
            {...bannerBlockItem}
            numPerRow={productsBlock.numPerRow}
            lazyLoadImage={true}
          />
        </div>
        {firstTwoProducts && (
          <div className="grid grid-cols-2 gap-1">
            {firstTwoProducts.map((product, idx) => (
              <ProductCard
                key={product.id + 'mixed' + idx}
                product={product}
                lazyLoadImage={true}
              />
            ))}
          </div>
        )}
        {showBannerToTheRight && (
          <div className="md-down:hidden">
            <BannerItem
              className="banner-item [&_p]:text-white [&_h2]:text-white lg:h-full lg:[&_.banner-item__image]:h-full lg:[&_.banner-item__image]:aspect-auto"
              {...bannerBlockItem}
              lazyLoadImage={true}
            />
          </div>
        )}
      </div>
      {remainingProducts?.length ? (
        <div className="grid grid-cols-2 gap-1 mt-1 lg:grid-cols-4">
          {remainingProducts.map((product, idx) => (
            <ProductCard
              key={product.id + 'mixed' + idx}
              product={product}
              lazyLoadImage={true}
            />
          ))}
        </div>
      ) : null}
    </>
  );
};

export default ProductsAndBannerBlock;
